import { render, staticRenderFns } from "./StatusCounters.vue?vue&type=template&id=1d964941&scoped=true"
import script from "./StatusCounters.vue?vue&type=script&lang=js"
export * from "./StatusCounters.vue?vue&type=script&lang=js"
import style0 from "./StatusCounters.vue?vue&type=style&index=0&id=1d964941&prod&scoped=true&lang=css"
import style1 from "./StatusCounters.vue?vue&type=style&index=1&id=1d964941&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d964941",
  null
  
)

export default component.exports